import React from "react";
import Footer from "../Fotter";

function UseIt() {
  return (
    <div>
      <div className="container mx-auto px-4 py-6">
        <h1 className="text-3xl font-bold mb-6">Order Details and More</h1>

        {/* How to Order Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">How to Order?</h2>
          <ol className="list-decimal pl-6 text-gray-700 space-y-2">
            <li>
              Open{" "}
              <a
                href="https://www.gwsshopsy.com/"
                className="text-blue-500 underline"
              >
                https://www.gwsshopsy.com/
              </a>
            </li>
            <li>Choose your product</li>
            <li>Click on the “Add to Cart” button</li>
            <li>Click on the “Proceed to Checkout” button</li>
            <li>Fill in all your billing details on the checkout page</li>
            <li>
              Check your order details and click on the “Place Order” button
            </li>
            <li>
              Select your convenient payment option and click on the “Pay”
              button
            </li>
          </ol>
          <p className="mt-4 text-gray-600">
            After successful payment, you’ll receive an order confirmation via
            email, SMS, or WhatsApp. You’ll receive your ordered product within
            7-8 working days from the order date.
          </p>
        </div>

        {/* How to Return or Refund Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            How to Return or Refund My Order?
          </h2>
          <p className="text-gray-700 mb-2">
            GWS Shopsy refund & return policies are well mentioned on our
            website.
          </p>
          <p className="text-gray-700">
            Also, contact GWS Shopsy Customer Care for return & refund orders.
          </p>
        </div>

        {/* How to Change Address or Contact Number Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            How to Change My Address or Contact Number?
          </h2>
          <p className="text-gray-700">
            To change any details of your order, contact GWS Shopsy Customer
            Care.
          </p>
        </div>

        {/* How to Cancel My Order Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            How to Cancel My Order?
          </h2>
          <p className="text-gray-700">
            In the "My Account" section, go to “Orders” and click on the cancel
            button in the actions column.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default UseIt;
